var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatSendMessageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.052,
    height: 14.969,
    viewBox: "0 0 17.052 14.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "send",
    d: "M32.364,54.456l-.006,0L17.185,48.079a.828.828,0,0,0-.789.078.89.89,0,0,0-.4.741v4.077a.861.861,0,0,0,.694.848l8.276,1.55a.144.144,0,0,1,0,.283L16.694,57.2a.861.861,0,0,0-.694.847V62.13a.849.849,0,0,0,.846.852.863.863,0,0,0,.338-.069l15.173-6.338.007,0a1.157,1.157,0,0,0,0-2.116Z",
    transform: "translate(-16 -48.013)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatSendMessageIcon);
export default __webpack_public_path__ + "static/media/live-chat-send-message-icon.35e3be256d75e84e3fefb27b498acc80.svg";
export { ForwardRef as ReactComponent };